import React, { Component } from "react";
import DetectRTC from 'detectrtc'

import Responsive from "../../components/Responsive";
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import CustomLoader from "../../components/CustomLoader";
import LoaderButton from "../../components/LoaderButton";
import store from "../../stores/storeConfig";
import * as actions from "../../stores/actionsList";
import ButtonAnimated from "../../components/buttons/ButtonAnimated";

let localMediaStream;

class RoomLobby extends Component {

    state = {
        cameras: [],
        positions: [],
        useVideo: false,
        useAudio: false
    }



    componentDidMount() {
        // let path = window.location.pathname
        // path = path.split('/')[-1]
        // // console.log(path)
        // console.log(path)
        // this.setState({ path }, () => {
        this.fetchRoom()
        // })

        // this.constraints = {
        //     video: true,
        //     audio: {
        //         echoCancellation: true,
        //         noiseSuppression: true,
        //         sampleRate: 44100,
        //     }
        // }
        // navigator.mediaDevices.getUserMedia(this.constraints).then(stream => {


        // this.props.stream = stream;
        // localMediaStream = this.props.localMediaStream



        // }).catch(function (error) {
        //     alert(error)
        // })

    }

    componentDidUpdate = () => {


    }



    fetchRoom = () => {

        this.setState({ isLoadingRoomInfo: true })

        HttpServices.request('getRoomInfo', { id: this.props.roomId }, (fetchResult, fetchError) => {

            this.setState({ isLoadingRoomInfo: false })

            if (fetchError) {
                return
            }

            // console.log(fetchResult)

            this.setState({ roomInfo: fetchResult?.info })

        })
    }



    playVideo = () => {
        // console.log("playVideo")
        // console.log(this.props.localMediaStream)
        this.setLocalVideo(0)
    }
    setLocalVideo = (tryTime, cb) => {
        if (this.localVideo && this.localVideo.play) {
            this.localVideo.srcObject = this.props.localMediaStream;
            this.localVideo.play()
            if (cb) {
                cb()
            }
        }
        else {
            if (tryTime <= 10) {
                setTimeout(() => {
                    this.setLocalVideo((tryTime + 1), cb)
                }, 70);
            }
        }
    }
    componentWillUnmount() {
        // if (this.props.stream) {
        //     this.props.stream.getTracks().forEach(function (track) {
        //         console.log(track)
        //         track.stop();
        //     });
        // }
        store.dispatch(actions.removeCall())
    }


    joinRoomRequest = () => {
        // console.log('{joinRoomRequest}')

        if (this.props.localMediaStream) {
            this.props.handleSocket()
            // this.setState({ joinRoom: true })
            // if (this.props.stream) {
            //     this.props.stream.getTracks().forEach(function (track) {
            //         console.log(track)
            //         track.stop();
            //     });
            // }
            setTimeout(() => {
                this.props.handleJoinRequest()
            }, 200);
        }
        // this.props.joinRoom()
    }
    joinRoom = () => {
        // console.log('thissssprosss', this.props)
        this.props.joinRoom()
    }

    // stopBroadcasting = () => {
    //     if (this.props.stream) {
    //         // console.log('stoprecording');
    //         this.props.stream.getTracks().forEach(function (track) {
    //             track.enabled = !track.enabled

    //         })
    //         let useVideo = this.props.useVideo
    //         useVideo = !useVideo
    //         this.props.setData('useVideo', useVideo)

    //     }
    // }



    render() {
        return (
            <div className={"room-lobby h-100 scroll-no-scrollbar " + (conditionalWidth(this.props.width, { xs: ' d-block scroll-no-scrollbar ', md: ' d-flex ' }))} style={{ flex: 1, background: '#fff' }}>
                <Responsive height={conditionalWidth(this.props.width, { xs: '  ', md: ' 100% ' })} width={this.props.width} media={{ xs: "12", md: '7', lg: "6", xl: "6" }}>
                    <div className="px-5 pt-5 w-100 pb-4">


                        <div className="w-100  flexcc h-100 flex-column ">
                            <div className="w-100" >
                                <div className="w-100 position-relative">
                                    <video className="local-video w-100" muted playsinline autoPlay={true} ref={vid => this.localVideo = vid} ></video>

                                    {!this.props.useVideo && (
                                        <div className="flex-1 w-100 h-100 position-absolute top-0 left-0 br-10 flexcc px-2 py-2" style={{ background: '#000' }}>
                                            <p className="text-bold text-white">{translate("Camera is off")}</p>
                                        </div>

                                    )}
                                </div>



                            </div>
                            <div className="w-100 pt-3 flexcc flexc-column">
                                <div onClick={() => this.props.toggleStopCamera()} className="flexcc cursor-pointer mx-2" style={{ padding: 8, borderRadius: 40, background: !this.props.useVideo ? 'linear-gradient(to left, #FF3B30, #FF3B30' : 'linear-gradient(to left, #34C759, #34C759' }} >
                                    <img className="" src={!this.props.useVideo ? "/assets/icons/rooms/video.slash.svg" : "/assets/icons/rooms/video.svg"} height={30} alt="" />
                                </div>
                                <div onClick={() => this.props.toggleMuteAudio()} className="flexcc cursor-pointer mx-2" style={{ padding: 8, borderRadius: 40, background: !this.props.useAudio ? 'linear-gradient(to right, #FF3B30, #FF3B30' : 'linear-gradient(to right, #34C759, #34C759' }} >
                                    <img className="" src={!this.props.useAudio ? "/assets/icons/rooms/mic.slash.svg" : "/assets/icons/rooms/mic.svg"} height={30} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Responsive>


                <Responsive height={conditionalWidth(this.props.width, { xs: '  ', md: ' 100% ' })} width={this.props.width} media={{ xs: "12", md: '5', lg: "6", xl: "6" }}>
                    <div className={"h-100  text-center flexc flex-column px-4  window-content-radius " + (conditionalWidth(this.props.width, { xs: 'py-4', md: 'py-5' }))} style={{ backgroundColor: '#f6f6f6' }}>
                        {/* <img className="mb-3" src="/assets/icons/portals/roomtest.svg" height={120} /> */}

                        {(!this.state.roomInfo && !this.state.isLoadingRoomInfo) && (
                            <div className="pt-3">
                                <img src="/assets/icons/useful/page.png" height={60} alt="" />
                                <p className="text-semibold font-size-16">{translate("Link is not valid")}</p>
                                <p className="font-size-14">{translate("Please double check the link")}</p>

                            </div>
                        )}

                        {this.state.roomInfo && (

                            <>
                                <div className="position-relative mb-2">
                                    <img className="" src={imageAddress(this.state.roomInfo?.applet?.image, 'applet', 'mini')} height={50} alt="" />
                                    <div className="position-absolute" style={{ bottom: -5, right: -5 }}>
                                        <img className=" br-20" src={imageAddress(this.state.roomInfo?.owner?.image, 'applet', 'mini')} height={24} alt="" style={{ border: '2px solid #fff' }} />
                                    </div>
                                </div>


                                {/* <p className="font-size-20 weight-600">{translate("rooms.Join Room")}</p> */}
                                <p className="font-size-14 text-bold">{this.state.roomInfo?.name ?? checkTranslation(this.state.roomInfo?.frame?.name)} - {this.state.roomInfo?.owner?.fullname}</p>
                                {/* <p className="font-size-14 text-bold">{}</p> */}
                                <p className="text-smaller mt-3 mb-2">{translate("rooms.You are joining this room as")}</p>
                                <p>{'@' + this.props.user.username}</p>

                                <div className="mt-4">
                                    {/* {!this.props.isLoadingJoin ? (
                                        <> */}
                                    {/* <button onClick={() => this.joinRoomRequest()} className='px-1 py-1  flexcc mt-3' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right,#9564FE, #7064FE)', borderRadius: 8, color: '#fff', transition: 'all 0.5s' }}>
                                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("rooms.Join Room")}</p>
                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                                        <img className='invert rtl-button' src='/assets/icons/angle-right.svg' height={18} />
                                    </div>
                                </button> */}
                                    <ButtonAnimated bg={'linear-gradient(to right,#9564FE, #7064FE)'} title='Join Room' icon={'/assets/icons/arrow-right-white.svg'} onClick={this.joinRoomRequest} isLoading={this.props.isLoadingJoin} />
                                    {/* </>
                                    ) : (
                                        <>
                                            {this.props.joinRoomApproved ? (
                                                <div>
                                                    {this.joinRoom()}
                                                </div>
                                            ) : (
                                                <ButtonAnimated bg={'linear-gradient(to right,#9564FE, #7064FE)'} title='Join Room' icon={'/assets/icons/arrow-right-white.svg'} onClick={this.joinRoomRequest} isLoading={true} />
                                            )}
                                        </>
                                    )} */}

                                    {this.props.requestRejected && (
                                        <p className="text-smaller mt-3  mb-0 px-4 color-red ">{translate("Join request was rejected by admin")}</p>
                                    )}


                                    {(!this.props.isLoadingJoin || !this.props.roomIsLocked) && (
                                        <p className="text-smaller mt-3  mb-4 px-4">{translate("Click join room to proceed entering the room.")}</p>
                                    )}

                                    {(this.props.isLoadingJoin && this.props.roomIsLocked) && (
                                        <p className="text-smaller mt-3  mb-4 px-4">{translate("Please wait till someone let's you in.")}</p>
                                    )}
                                </div>


                            </>
                        )}
                    </div>
                </Responsive >
            </div >
        )
    }



}


export default RoomLobby;